<sh-search-bar [tag]="tag" [enableAdvancedSearch]="enableAdvancedSearch$ | async" [actionItems]="searchBarActionItems$ | async" [tagLimitedButtons]="true"></sh-search-bar>
